import React,{useEffect, useState} from 'react'
import Navbar from './components/Navbar'
import "./App.css"
import { 
  BrowserRouter as Router,
  Routes,
  Route
 } from 'react-router-dom'
import Home from './components/Home'
import Contact from './components/Contact'
import Brands from './components/Brands'
import Category from './components/Category'
import CategoryStore from './components/CategoryStore'
import AdminLogin from './components/AdminLogin'
import AdminPanel from './components/AdminPanel'
// import authfetch from './components/authfetch'
import IndividualBrandDesc from './components/IndividualBrandDesc'
import IndividualProduct from './components/IndividualProduct'
import Search from './components/Search'
import RecentView from './components/RecentView'
import { StoreProvider } from './context/StoreContext'
import Loading from './components/subcomponents/Loading';
import { useStore } from './context/StoreContext';
import EditProductDetail from './components/subcomponents/EditProductDetail'
import Toast from './components/subcomponents/Toast';
import TawkTo from './components/TawkTo';

const AppContent = () => {
  const { isLoading } = useStore();
  const [navLocation,setNavLocation] = useState("/")


  return (
    <>
    {isLoading && <Loading />}
    <EditProductDetail />
    <Toast />
    <TawkTo />
    
    <Navbar navLocation={{navLocation,setNavLocation}}/>
    <div className='alertbox'></div>
    <Routes>

      <Route path='/home' Component={Home}></Route>
      <Route path='/contact' Component={Contact}></Route>
      <Route path='/brands' Component={Brands}></Route>
      <Route path='/brands/:brandname' Component={IndividualBrandDesc}></Route>
      <Route path='/category' Component={Category}></Route>
      <Route path='/category/:category' element={<CategoryStore />}></Route>

      <Route path="/" Component={Home}></Route>
      <Route path="/admin" element={<AdminLogin />}></Route>
      <Route path="/adminpanel" Component={AdminPanel}></Route>
      <Route path="/search" Component={Search}></Route>
      <Route path="/product/:productId" Component={IndividualProduct}></Route>
      <Route path="/recentview" Component={RecentView}></Route>
    </Routes>
    </>
  );
}

export default function App() { 
  
  return (
    <Router>
      <StoreProvider>
        <AppContent />
      </StoreProvider>
    </Router>
  )
}
